import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import * as IssueService from 'services/agents/issue';

export const useIssueService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchIssues = async (options = {}) => {
    const { error, payload } = await IssueService.read({ ...options, token });
    if (error) {
      toast.error('Unable to fetch issues at this time.');
      return { issues: [], size: 0 };
    }

    const issues = payload?.data || payload?.issues || [];
    const size = payload?.meta?.size ?? issues.length;
    return { issues, size };
  };

  const fetchIssue = async (id, options = {}) => {
    const { error, payload } = await IssueService.readById(id, { ...options, token });
    if (error) {
      toast.error('Unable to fetch issue at this time.');
      return { issue: null };
    }

    const issue = payload?.data || payload?.issue || payload || null;
    return { issue };
  };

  const createIssue = async (data, options = {}) => {
    const { error, payload } = await IssueService.create({ ...options, data, token });
    if (error) {
      toast.error(error || 'Unable to create issue at this time.');
      return { issue: null };
    }

    toast.success('Issue created successfully.');
    const issue = payload?.data || payload?.issue || payload || null;
    return { issue };
  };

  const updateIssue = async (id, data, options = {}) => {
    const { error, payload } = await IssueService.updateById(id, { ...options, data, token });
    if (error) {
      toast.error(error || 'Unable to update issue at this time.');
      return { issue: null };
    }

    toast.success('Issue updated successfully.');
    const issue = payload?.data || payload?.issue || payload || null;
    return { issue };
  };

  const fetchIssueReports = async (id, options = {}) => {
    const { error, payload } = await IssueService.readReports(id, { ...options, token });
    if (error) {
      toast.error('Unable to fetch reports at this time.');
      return { reports: [], size: 0 };
    }

    const reports = payload?.data || payload?.reports || [];
    const size = payload?.meta?.size ?? reports.length;
    return { reports, size };
  };

  const searchIssues = async (keyword, options = {}) => {
    const { error, payload } = await IssueService.searchByTitle(keyword, { ...options, token });
    if (error) {
      toast.error('Unable to search issues at this time.');
      return { issues: [] };
    }

    const issues = payload?.data || payload?.issues || [];
    return { issues };
  };

  return { fetchIssues, fetchIssue, createIssue, updateIssue, fetchIssueReports, searchIssues };
};
